import type { QuickbetSelection } from '@core/Areas/Quickbet/types'
import type { LoadBetDetails } from '@core/Areas/ShareBet/LoadBet/types'
import { isFOOBetDetails, isKambiSportBetDetails } from '@core/Areas/ShareBet/LoadBet/typeGuards'
import { buildStandardRacingBet, buildFixedOddsOnlyRacingBet, buildKambiSportsBet } from './helpers'
import type { BuildBetSelectionOptions } from './types'

export async function buildBetSelection(
  bet: LoadBetDetails,
  opts: BuildBetSelectionOptions = {}
): Promise<QuickbetSelection> {
  if (isFOOBetDetails(bet)) {
    const selection = await buildFixedOddsOnlyRacingBet(bet, opts)
    return selection
  }

  if (isKambiSportBetDetails(bet)) {
    const selection = await buildKambiSportsBet(bet)
    return selection
  }

  const selection = await buildStandardRacingBet(bet, opts)
  return selection
}
